import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { TestWidgetMessengerMenu as View } from './TestWidgetMessengerMenu'

// @ts-ignore
export const TestWidgetMessengerMenu = withStyles(styles)(View)
